// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"b6d4a29b","297":"6335d293","643":"2f2a8bb3","787":"fec03637"}[chunkId] + ".chunk.js";
};